import React, { useContext, useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { List } from "antd-mobile";
import { Empty } from "antd";
import axios from "axios";
import PsContext from "../../context";
import { ServiceUrl } from "../../utils/serviceUrl";
import { Row } from "react-bootstrap";

const AttendanceStudentList = (props) => {
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const context = useContext(PsContext);

  useEffect(() => {
    //console.log('props.dataSource:', props.dataSource);
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);

    const form = new FormData();
    form.append("staff_id", context.user.id);
    form.append("srv_org_id", props.dataSource.srv_org_id);
    form.append("date", props.dataSource.date);

    axios.post(ServiceUrl.MOB.LIST_SERVICE_ATTENDANCE, form).then((res) => {
      if (res.data.status === "1") {
        setDataView(res.data.data);
        setDataList(res.data.data);
        //console.log('Received data:', res.data.data);
      }
      setLoader(false);
    }).catch(error => {
      //console.error('Error fetching data:', error);
      setLoader(false);
    });
  };

  const getBackgroundColor = (attendances) => {
    switch (attendances.toUpperCase()) {
      case 'P':
        return '#e0f7e0'; 
      case 'L':
        return '#f0f0f0';  
      case 'A':
        return '#fcd5d5'; 
      default:
        return 'white';  
    }
  };

  return (
    <>
      <Card>
        <Row>
          {dataView.length > 0 ? (
            <List>
              {dataView.map((item, i) => (
                <List.Item
                  key={i}
                  style={{ backgroundColor: getBackgroundColor(item.attendances) }}
                  description={item.registerno || item.admissionno}
                >
                  {item.name} - {item.attendances.toUpperCase()}
                </List.Item>
              ))}
            </List>
          ) : (
            <div className="mt-5">
              <Empty description="There is No Attendance" />
            </div>
          )}
        </Row>
      </Card>
    </>
  );
};

export default AttendanceStudentList;
